/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_BlankInputs */

const en_gc_editor_blank = /** @type {(inputs: Gc_Editor_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blank workbook`)
};

const zh_gc_editor_blank = /** @type {(inputs: Gc_Editor_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白工作簿`)
};

/**
* | output |
* | --- |
* | "Blank workbook" |
*
* @param {Gc_Editor_BlankInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_blank = /** @type {((inputs?: Gc_Editor_BlankInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_BlankInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_blank(inputs)
	return zh_gc_editor_blank(inputs)
});
export { gc_editor_blank as "gc.editor.blank" }